import uuid from 'uuid/v1';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';

const items = [];
const reusableItems = [];
const components = [
  { content: 'Carousel', readableName: 'Carousel' },
  { content: 'CarouselTickets', readableName: 'Tickets' },
  { content: 'CarouselWithDescription', readableName: 'Carousel with Description' },
  { content: 'CollapsibleList', readableName: 'Collapsible' },
  { content: 'ContactFormReusable', readableName: 'Contact Form' },
  { content: 'FilterContainer', readableName: 'Filter' },
  { content: 'FullLink', readableName: 'Link' },
  { content: 'Gallery', readableName: 'Gallery' },
  { content: 'InstructionsSimpleUploadLogo', readableName: 'Instructions' },
  { content: 'LineupList', readableName: 'Artists List' },
  { content: 'LineupContainerSimple', readableName: 'Collapsible FAQs' },
  { content: 'LogosRowModule', readableName: 'Logos Row' },
  { content: 'Launcher', readableName: 'Launcher' },
  { content: 'Map', readableName: 'Map' },
  { content: 'MediaDescription', readableName: 'Image' },
  { content: 'MediaTitle', readableName: 'Double Title' },
  { content: 'Pdf', readableName: 'Pdf' },
  { content: 'NormalBodyText', readableName: 'Paragraph' },
  { content: 'PostDescriptionRow', readableName: 'Media Row' },
  { content: 'Separator', readableName: 'Separator' },
  { content: 'SpotifyPlayer', readableName: 'SpotifyPlayer' },
  { content: 'TitleLineH1', readableName: 'TitleH1' },
  { content: 'TitleLineH2', readableName: 'TitleH2' },
  { content: 'VideoPlayer', readableName: 'Video' },
  { content: 'TagsRow', readableName: 'Tags Row' },
  { content: 'LineupContainer', readableName: 'Lineup Container' },
  { content: 'PdfMagazineGallery', readableName: 'PDF Magazine Gallery' },
  { content: 'Postal', readableName: 'Postal' },
  { content: 'RadioChannel', readableName: 'Radio Channel' },
  { content: 'BrazeTrigger', readableName: 'Braze Log Event' },
  { content: 'MapBox', readableName: 'MapBox' },
  { content: 'MainNavMenu', readableName: 'Main Nav Menu' },
  { content: 'TicketsTabs', readableName: 'Tickets Tabs' },
  { content: 'Embed', readableName: 'Embed' },
  { content: 'LoginPaywall', readableName: 'Login Paywall' },
  { content: 'Wishlist', readableName: 'Wishlist' },
];

// Add reusable components to items
getPostsByType('component')
  .then((res) => {
    if (res) {
      const { posts } = res;
      Object.keys(posts).forEach((post) => {
        const mod = {
          id: uuid(),
          content: posts[post].slugName,
          readableName: posts[post].slugName,
          type: 'reusableItem',
        };
        reusableItems.push(mod);
      });
    }
  })
  .catch((err) => {
    console.log('TCL: err', err);
  });

components.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
  };
  items.push(mod);
});

export { reusableItems };
export default items;
